import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { InstanceModuleService } from 'src/app/areas/kms/serves/instance/instance.module';
import { SwAudioService } from 'src/app/librarys/components/basic-components/sw-audio/sw-audio.service';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { environment } from 'src/environments/environment';
import { KmsService } from '../../../kms.service';
import { KmsEnum } from '../../../serves/kms-enum';
import { EditDatasourceComponent } from '../../edit-datasource/edit-datasource.component';
declare var $;
@Component({
  selector: 'app-mark-add',
  templateUrl: './mark-add.component.html',
  styleUrls: ['./mark-add.component.css']
})
export class MarkAddComponent implements OnInit {
  //接收父组件的数据  
  @Input() bigImgUrl:string;              // 图片路径
  @Input() fileInfoId:string;             // 图片文件主键id
  @Input() currentMarkId:string;          // 标记id,新增时默认为空
  @Input() region:any = [];               // 小图的x,y,width,height
  @Input() operateState:string;           // 1: 编辑标记信息；2：修改区域图；3：描边；4：修改定位坐标   
  @Input() point:any = {};                  // 定位坐标  
  @Input() points:any = [];               // 描边点集合
  @Input() showMarkEdit:boolean;        // 标注编辑组件是否显示 
  // 新增或编辑标注成功后向父组件发射数据
  @Output('addMark') addMark = new EventEmitter<any>();   
  // 执行与区域图描边有关的操作时触发
  @Output('strokeOpe') strokeOpe = new EventEmitter<any>();
  // 执行与取点定位有关的操作时触发
  @Output('pointOpe') pointOpe = new EventEmitter<any>();
  // 表单内容发生变化时触发
  @Output('formValueChange') formValueChange = new EventEmitter<any>();
  // 表单状态
  addOrUpdate:string = 'Add';
  // 数据绑定对象
  markModel: any = {}; 
  // tab切换当前模块id
  tabId:string = 'markInfo'
  // 保存按钮是否可用
  clickEnable:boolean = true;
  // 已选择的标签数组
  selectedTags: any = [];
  // 音频上传文件策略
  fileCode:string = '';
  // 音频文件名称
  audioName:string = '';
  // 是否展示描边
  isShowStroke = false;
  // 是否展示定位点
  isShowPoint = false;
  // 数据来源
  sourceList:any = [];
  constructor(
    private create: SwCreateModalComponentService,
    private instanceModuleService: InstanceModuleService,
    private box: SwMassageBoxService,
    private kmsService: KmsService,
    private jwt: SwJwtService,
    private swAudioService: SwAudioService
  ) { }

  ngOnInit() {
    // 通过知识库标识拼接文件策略
    let kgDbInfo = JSON.parse(this.jwt.getToken('kgDbInfo'));
    let kgCode = kgDbInfo && kgDbInfo.englishCode ? kgDbInfo.englishCode : '';
    this.fileCode = kgCode ? KmsEnum.KMS_INSTANCE_RESOURCE + '_' + (kgCode.toUpperCase()) : '';
  }

  ngOnChanges() {
    if(this.showMarkEdit){
      const format = this.instanceModuleService.getImgFormat(this.bigImgUrl);
      // 判断是否为新增/编辑标注
      if(this.operateState === '1') {
        // 表单内容未改变
        this.formValueChange.emit(false);
        // 描边及取点查看功能初始化
        this.isShowStroke = false;
        this.isShowPoint = false;
        this.tabId = 'markInfo';
        // 查询标记详情
        if (this.currentMarkId) {
          if(this.currentMarkId != this.markModel.imageMarkId){
            this.addOrUpdate = 'Edit';
            // 查询标注信息
            this.kmsService.queryImgMarkById(this.currentMarkId).subscribe(
              data => {
                if (data.code == '200') {
                  let res = data.data;
                  this.markModel.fileInfoId = res.fileInfoId ? res.fileInfoId : '';
                  this.markModel.imageMarkId = res.imageMarkId;
                  this.markModel.markName = res.markName;
                  this.markModel.markNote = res.markNote;
                  this.markModel.markNoteAudio = res.markNoteAudio;
                  this.markModel.point = res.point ? res.point : '';
                  this.markModel.points = res['points'] ? JSON.parse(res['points']) : [];
                  this.markModel.imgUrl = this.bigImgUrl + res.position + ',' + res.width + ',' + res.height + '/full/0/default.' + format;
                  this.markModel.width = res.width;
                  this.markModel.height = res.height;
                  this.markModel.position = res.position;
                  this.markModel.instanceId = res.instanceId ? res.instanceId : '';
                  this.markModel.masksImgPath1 = res.masksImgPath ? environment.staticFileUrl + res.masksImgPath : '';
                  this.markModel.sortNum = res.sortNum;
                  this.selectedTags = res.tags && res.tags.length>0 ? res.tags : [];
                  this.sourceList = res.datasources && res.datasources.length>0 ? res.datasources : [];
                  if(this.markModel.markNoteAudio){
                    let path = this.markModel.markNoteAudio.split('/');
                    this.audioName = path[path.length - 1];
                  }
                } else {
                  console.log('服务器异常，请稍候再试！');
                }
              }
            );
          }
        } else {
          this.addOrUpdate = 'Add';
          // 标注信息初始化
          this.markModel.fileInfoId = this.fileInfoId;
          this.markModel.imageMarkId = '';
          this.markModel.markName = '';
          this.markModel.markNote = '';
          this.markModel.markNoteAudio = '';
          this.markModel.points = [];
          this.markModel.imgUrl = this.bigImgUrl + this.region.join(',') + '/full/0/default.' + format;
          this.markModel.width = this.region[2];
          this.markModel.height = this.region[3];
          this.markModel.position = this.region[0]+','+this.region[1];
          this.markModel.instanceId = '';
          this.selectedTags = [];
          this.sourceList = [];
          this.getExhibitPosition();
        }
      }
      // 判断是否仅修改区域图
      else if(this.operateState === '2') {
        // 表单内容改变
        this.formValueChange.emit(true);

        // 拼接区域图路径
        this.markModel.imgUrl = this.bigImgUrl + this.region.join(',') + '/full/0/default.' + format;
        this.markModel.width = this.region[2];
        this.markModel.height = this.region[3];
        this.markModel.position = this.region[0]+','+this.region[1];
        this.getExhibitPosition();
      }
      // 判断是否仅修改区域图描边
      else if (this.operateState === '3'){
        // 表单内容改变
        this.formValueChange.emit(true);

        if(this.points.length > 0){
          this.markModel.points = this.points;
          this.isShowStroke = true;
        }else{
          this.markModel.points = this.points;
          this.isShowStroke = false;
        }
        if(this.isShowPoint){
          this.isShowPoint = false;
        }
      }
      // 判断是否仅修改定位坐标
      else if(this.operateState === '4'){
        // 表单内容改变
        this.formValueChange.emit(true);

        if(this.point.x){
          this.markModel.point = this.point.x + ',' + this.point.y;
          this.isShowPoint = true;
        }else{
          this.markModel.point = '';
          this.isShowPoint = false;
        }
        if(this.isShowStroke){
          this.isShowStroke = false;
        }
      } 
    }else{
      if(!this.currentMarkId){
        this.markModel.imageMarkId = '';
        this.isShowStroke = false;
        this.isShowPoint = false;
      }
      // 表单内容改变
      this.formValueChange.emit(false);
    }
  }

  // 表单输入项内容发生变化
  handleFormChange(){
    this.formValueChange.emit(true);
  }

  // 获取定位坐标
  getExhibitPosition(){
    let x = this.region[0] + this.region[2] / 2;
    let y = this.region[1] + this.region[3] / 2;
    this.markModel.point = x + ',' + y;
    this.point = {
      x: x,
      y: y
    }
  }

  // 查看描边/关闭描边功能
  drawStroke(state){
    if(this.markModel.points.length == 0){
      return;
    }
    if(this.isShowPoint){
      this.isShowPoint = false;
    }
    if(state == 'open'){
      this.isShowStroke = true;
    }else if(state == 'close'){
      this.isShowStroke = false;
    }else if(state == 'empty'){
      this.isShowStroke = false;
    }
    // 向父组件发射数据
    this.strokeOpe.emit({state: state});
  }

  // 查看定位坐标/关闭定位坐标功能
  drawPoint(state){
    if(!this.markModel.point){
      return;
    }
    if(this.isShowStroke){
      this.isShowStroke = false;
    }
    if(state == 'open'){
      this.isShowPoint = true;
    }else if(state == 'close'){
      this.isShowPoint = false;
    }else if(state == 'empty'){
      this.isShowPoint = false;
    }
    // 向父组件发射数据
    this.pointOpe.emit({state: state});
  }

  // tab切换
  handleTabClick(id){
    if(this.markModel.imageMarkId){
      this.tabId = id;
    }else{
      this.box.danger('请先保存当前标记信息！')
    }
  }

  // 生成音频文件
  getAuido(){
    let text = $.trim(this.markModel.markNote);
    if(text){
      if(!this.fileCode){
        this.box.waring('知识库标识不存在！');
        return;
      }
      this.kmsService.geneTextAudio('strategyCode='+this.fileCode+'&text='+text).subscribe(
        data => {
          if(data.code == '200'){
            if(data.data && data.data.fileInfoId){
              this.box.success('音频文件已生成!');
              this.markModel.markNoteAudio = data.data.filePath + data.data.fileName;
              this.audioName = data.data.fileName;
              this.formValueChange.emit(true);
            }else{
              this.box.waring('音频文件生成失败!');
            }
          }else{
            this.box.waring(data.msg);
          }
        }
      )
    }else{
      this.box.danger('请先输入标记描述信息！')
    }
  }

  // 音频试听方法
  audioPlay() {
    if(this.markModel.markNoteAudio){
      let title = this.markModel.markName ? this.markModel.markName : '音频播放';
      this.swAudioService.openAudio(title, environment.staticFileUrl + this.markModel.markNoteAudio);
    }
  }

  // 保存标记信息
  onSubmit({ value, valid }, event: Event){
    if(valid){
      if(environment.isSourceRequired && this.sourceList.length == 0){
        this.box.danger('请录入数据来源！');
        return;
      }
      let tagIds = [];
      if(this.selectedTags.length>0){
        this.selectedTags.forEach(item => {
          tagIds.push(item.tagId);
        });
      }
      let params = {
        "imageMarkId": value.imageMarkId,
        "fileInfoId": value.fileInfoId,
        "markName": value.markName,
        "markNote": value.markNote,
        "markNoteAudio": value.markNoteAudio,
        "width": this.markModel.width,
        "height": this.markModel.height,
        "position": this.markModel.position,
        "point": this.markModel.point,
        "points": this.markModel.points.length>0 ? JSON.stringify(this.markModel.points) : '',
        "tagIds": tagIds,
        "datasources": this.sourceList,
        "instanceId": this.markModel.instanceId,
        "sortNum": this.markModel.sortNum
      }
      this.kmsService.saveOrUpdateImgMark(params).subscribe(
        data => {
          if(data.code == '200'){
            this.markModel.imageMarkId = data.data.imageMarkId;
            this.addMark.emit({
              imageMarkId: data.data.imageMarkId,
              markName: data.data.markName
            });
            this.formValueChange.emit(false);
            this.box.success('保存成功！');
          }else{
            this.box.danger(data.msg);
          }
        }
      )
    }
  }

  // 已选择标签发生变化时重新获取
  tagsChange(event){
    this.selectedTags = event;
    // 表单内容改变
    this.formValueChange.emit(true);
  }

  // 选择关联实体发生变化
  handleInstanceChange(event){
    console.log(event);
  }

  // 选中素材内容，填充到输入框中
  handleFillClick(key) {
    let data = this.jwt.getToken('materialTextSelect') ? JSON.parse(this.jwt.getToken('materialTextSelect')) : null;
    if(data){
      this.markModel[key] = data.sourceText;
    }
    this.jwt.setToKen('materialTextSelect','');
  }

  // 查看来源方法
  handleSourceEditClick() {
    const data = {
        state: 'edit',
        sourceList: this.sourceList
    }
    this.create.createModal(EditDatasourceComponent, data, this.editDatasourceFunction.bind(this));
  }

  // 编辑属性来源回调函数
  editDatasourceFunction(event){
    this.sourceList = event.data;
    this.sourceList.forEach(element => {
      element['imageMarkId'] = this.markModel.imageMarkId;
    });
  }
}
